export default "__VITE_ASSET__CJz2GCuI__"